import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { TStaticPages } from "../../types/staticPages";
import $api, { API } from "../index";

export const getStaticPages = createAsyncThunk(
  `getStaticPages`,
  async (id: string, { rejectWithValue }): Promise<TStaticPages[]> => {
    try {
      const response = await $api.get(`${API.getStaticPages}`);
      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const getStaticPageById = createAsyncThunk(
  `getStaticPageById`,
  async (id: string, { rejectWithValue }): Promise<TStaticPages> => {
    try {
      const response = await $api.get(`${API.getStaticPageById}${id}`);
      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);
